import Airtable from "airtable";

const API_KEY = process.env.REACT_APP_API_KEY;
const AIRTABLE_API_TOKEN = process.env.REACT_APP_AIRTABLE_API_TOKEN;
const BASE_ID = process.env.REACT_APP_BASE_ID;


// Airtable API configuration
const base = new Airtable({ apiKey: AIRTABLE_API_TOKEN }).base(BASE_ID);

export default base;